/**
 * 24K.Infinity Provider Portal — backend URL resolution.
 *
 * Modes:
 *   - Cloud: hostname matches 24k.infinity.{surbana.tech,com} → use api.24k.infinity.{tld}
 *   - LAN:   IP address → same IP, backend port from the local 440x block
 *   - Local: localhost → http://localhost:4400 (or REACT_APP_API_URL)
 */

function detectMode() {
  const h = (typeof window !== 'undefined' && window.location && window.location.hostname) || '';
  if (/\.infinity\.surbana\.tech$/i.test(h) || /\.24k\.infinity\.com$/i.test(h)) return 'cloud';
  if (/^\d+\.\d+\.\d+\.\d+$/.test(h)) return 'lan';
  if (h === 'localhost' || h === '127.0.0.1' || h === '::1') return 'localhost';
  return 'localhost';
}

export function getApiBase() {
  try {
    const { protocol, hostname } = window.location;
    const envUrl = process.env.REACT_APP_API_URL;
    const mode = detectMode();

    switch (mode) {
      case 'cloud': {
        // 24k.infinity.surbana.tech → api.24k.infinity.surbana.tech
        const apiHost = hostname.replace(/^24k\./, 'api.24k.');
        return `${protocol}//${apiHost}`;
      }
      case 'lan': {
        const p = Number(window.location.port);
        const backendPort = p ? p - (p % 10) : 4400;
        return `${protocol}//${hostname}:${backendPort}`;
      }
      case 'localhost':
      default:
        if (envUrl) return envUrl.replace(/\/$/, '');
        return 'http://localhost:4400';
    }
  } catch (err) {
    console.error('[apiBase] error detecting URL:', err);
    return 'http://localhost:4400';
  }
}

export function getBackendOrigin() {
  return getApiBase();
}
